import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";
import { CircularProgress, TextField, Button } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import PersonOutlined from "@material-ui/icons/PersonOutlined";
import LockOutlined from "@material-ui/icons/LockOutlined";
import instance from "../../store/actions/instance";
import { setUser } from "../../store/actions/auth";
import { Redirect } from "react-router";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";

class index extends Component {
  state = {
    email: this.props.history.location?.state?.email || "",
    code: "",
    errors: {},
    errorText: "",
    emailSent: false,
    takeNewPassword: false,
    password: "",
    showPassword: false,
  };

  validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  submit = async () => {
    const { email, password } = this.state;
    let errors = { email: false };
    if (!this.state.emailSent) {
      if (!email.trim() || !this.validateEmail(email.trim())) {
        if (!email.trim()) errors.email = true;
        else if (!this.validateEmail(email.trim()))
          errors.email = this.t("Invalid email address");
        this.setState({ errors: errors });
        return;
      }
    } else if (!this.state.code || this.state.code.length !== 6) {
      errors.code = this.t("Invalid verification code");
      this.setState({ errors: errors });
      return;
    } else if (this.state.takeNewPassword) {
      if (!password.trim() || password.trim().length < 8) {
        if (!password.trim()) errors.password = true;
        if (password.trim() && password.trim().length < 8)
          errors.password = this.t("Minimum length is 8 characters");

        this.setState({ errors: errors });
        return;
      }
    }

    this.setState({ loading: true, errorText: "" });
    try {
      const res = await instance.post("/forgot-password/", this.state);
      if (!res.data.success) {
        if (res.data.message)
          this.setState({ errorText: this.t(res.data.message) });
      } else {
        if (!this.state.emailSent)
          this.setState({ emailSent: true, errorText: "" });
        else if (this.state.takeNewPassword)
          this.props.setUser(res.data.token, this.props.history);
        else this.setState({ takeNewPassword: true, errorText: "" });
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ loading: false });
  };
  t = (text) => {
    const { language } = this.props;
    if (language === "english") return text;

    const trans = {
      Email: "الايميل",
      "Log in": "تسجيل الدخول",
      "Invalid email address": "الايميل غير صحيح",
      "Please enter your email": "الرجاء ادخال الايميل",
      "Invalid verification code": "رمز تحقق خاطئ",
      "Your password was reset successfully!": "تم تغيير كلمة المرور بنجاح!",
      "Please enter your new password": "الرجاء ادخال كلمة المرور الجديدة",
      "An email was sent to": "تم ارسال ايميل الى",
      "with a 6 digit verification code. Please enter it below":
        "مع رمز تحقق مكون من 6 رموز. قم بإدخاله ادناه",
      "Verification code": "رمز التحقق",
      "Forgot Password": "نسيت كلمة المرور",
      Submit: "المتابعة",
      Password: "كلمة المرور",
      "Confirm password": "تأكيد كلمة المرور",
      "Minimum length is 8 characters": "الحد الأدنى 8 احرف",
      "The two passwords don't match": "لا يوجد تطابق بكلمتي المرور",
    };
    return trans[text] || text;
  };
  render() {
    const {
      language,
      auth,
      cart,
      cart_items,
      promo_items,
      customTexts,
      settings,
    } = this.props;
    const totalCartLength = cart_items.length + promo_items.length;
    if (this.props.auth.user) return <Redirect to="/" />;

    const inputLabelStyle = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 0 : "unset",
      left: language == "english" ? 0 : "unset",
    };
    return (
      <div
        className="text-center"
        style={{ backgroundColor: "white", minHeight: "100vh" }}
      >
        <div className="free-space-70-white"></div>
        <ProductHeader onBack={() => this.props.history.goBack()} />

        <div>
          <p
            style={{ fontWeight: "bold", fontSize: 20, marginTop: 15 }}
            className="text-center"
          >
            {this.t("Forgot Password")}
          </p>

          <div style={{ padding: "0px 15px" }}>
            {!this.state.emailSent && (
              <>
                <p>{this.t("Please enter your email")}</p>
                <TextField
                  fullWidth
                  label={this.t("Email")}
                  required
                  value={this.state.email.toLowerCase()}
                  //   InputProps={{
                  //     startAdornment: (
                  //       <InputAdornment position="start">
                  //         <PersonOutlined />
                  //       </InputAdornment>
                  //     ),
                  //   }}
                  onChange={(e) =>
                    this.setState({
                      email: e.target.value,
                      errors: { ...this.state.errors, email: false },
                      errorText: "",
                    })
                  }
                  error={!!this.state.errors.email}
                  helperText={
                    typeof this.state.errors.email === "string"
                      ? this.state.errors.email
                      : undefined
                  }
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />
              </>
            )}

            {this.state.emailSent && !this.state.takeNewPassword && (
              <>
                <p style={{ direction: language === "arabic" ? "rtl" : "ltr" }}>
                  {this.t("An email was sent to")}{" "}
                  <span style={{ fontWeight: "bold" }}>{this.state.email}</span>{" "}
                  {this.t(
                    "with a 6 digit verification code. Please enter it below"
                  )}
                </p>{" "}
                <TextField
                  fullWidth
                  label={this.t("Verification code")}
                  required
                  onChange={(e) =>
                    this.setState({
                      code: e.target.value,
                      errors: { ...this.state.errors, code: false },
                      errorText: "",
                    })
                  }
                  error={!!this.state.errors.code}
                  helperText={
                    typeof this.state.errors.code === "string"
                      ? this.state.errors.code
                      : undefined
                  }
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />
              </>
            )}

            {this.state.takeNewPassword && (
              <>
                <p>{this.t("Please enter your new password")}</p>{" "}
                <TextField
                  fullWidth
                  label={this.t("Password")}
                  className={"mb-4"}
                  required
                  type={this.state.showPassword ? "text" : "password"}
                  onChange={(e) =>
                    this.setState({
                      password: e.target.value,
                      errors: { ...this.state.errors, password: false },
                      errorText: "",
                    })
                  }
                  error={!!this.state.errors.password}
                  helperText={
                    typeof this.state.errors.password === "string"
                      ? this.state.errors.password
                      : undefined
                  }
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            this.setState({
                              showPassword: !this.state.showPassword,
                            })
                          }
                          edge="end"
                        >
                          {this.state.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />
              </>
            )}

            <div>
              {!!this.state.errorText && (
                <p
                  style={{ color: "red", fontWeight: "bold", marginTop: 15 }}
                  className="text-center mb-0"
                >
                  {this.state.errorText}
                </p>
              )}
              <Button
                variant="contained"
                className="my-4"
                style={{
                  backgroundColor: "#0099cc",
                  color: "white",
                  width: 250,
                  height: 50,
                }}
                size="large"
                disableElevation
                onClick={() => this.submit()}
              >
                {!this.state.loading ? (
                  <span className="bold">{this.t("Submit")}</span>
                ) : (
                  <span>
                    <CircularProgress
                      style={{ width: 30, height: 30, color: "white" }}
                    />
                  </span>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    language: state.store.language,
    auth: state.auth,
    settings: state.store.store.settings,
    cart_items: state.cart.cart,
    promo_items: state.cart.promo_items,
    customTexts: state.store.store.settings.custom_texts,
    branch: state.branch,
    address: state.customers?.address,
    pages: state.staticPages.pages,
    store: state.store.store,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (key, history) => dispatch(setUser(key, history)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
